<!-- SitesListComponent.vue -->
<template>
  <div>
    <h2>Sites List</h2>
    <ul>
      <li v-for="site in sites" :key="site.id">
        <strong>{{ site.name }}</strong> - {{ site.description }}
      </li>
    </ul>
    <button @click="fetchSites">Fetch Sites</button>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useSites } from '@/composables/useSites'

// Destructure the returned object from useSites
const { sites, fetchItems } = useSites()

// Function to fetch sites when the button is clicked
const fetchSites = async () => {
  try {
    await fetchItems()
  } catch (error) {
    console.error('Error fetching sites:', (error as Error).message)
  }
}

onMounted(() => {
  fetchSites()
})

console.log(sites)

console.log(sites.value)
</script>
